module.exports = __webpack_public_path__ + "img/thumb_26.25f444f4.jpg";